import script from "./CupPlayoffMatches.vue?vue&type=script&setup=true&lang=js"
export * from "./CupPlayoffMatches.vue?vue&type=script&setup=true&lang=js"

import "./CupPlayoffMatches.vue?vue&type=style&index=0&id=a76a2cfa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a76a2cfa"]])

export default __exports__